var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import PropTypes from "prop-types";
import Lottie from "react-lottie";
import classNames from "classnames";
import { createUseStyles } from "react-jss";
import Typography from "../Typography";
import { useGlobalContext } from "../Context";
import { defaultLottieOptions } from "../common/defaultLottieOptions";
var useStyles = createUseStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    var getVendorColor = function (props, option) {
        var activeStyles = props.vendorStyles.find(function (currentVendor) {
            return currentVendor.fields.vendor === props.vendor;
        });
        return activeStyles ? activeStyles.fields[option] : null;
    };
    return {
        root: (_a = {
                display: "block",
                position: "relative",
                margin: "0 auto",
                overflow: "hidden",
                height: "auto",
                width: "100%",
                backgroundColor: function (props) {
                    return getVendorColor(props, "backgroundColor");
                }
            },
            _a[theme.mediaQuery(theme.breakpoints.large)] = {
                minHeight: "900px",
            },
            _a),
        container: (_b = {
                display: "flex",
                position: "relative",
                alignItems: "center",
                flexDirection: "column",
                padding: "80px 40px",
                margin: "0 auto",
                overflow: "hidden",
                height: "auto",
                width: "100%",
                maxWidth: theme.maxWidth,
                backgroundColor: function (props) {
                    return getVendorColor(props, "backgroundColor");
                },
                color: function (props) {
                    return getVendorColor(props, "textColor");
                }
            },
            _b[theme.mediaQuery(theme.breakpoints.medium)] = {
                padding: "80px 120px 80px 60px",
            },
            _b[theme.mediaQuery(theme.breakpoints.large)] = {
                flexDirection: "row",
                minHeight: "900px",
                padding: "0px 120px",
            },
            _b),
        headline: {
            marginBottom: 26,
        },
        text: (_c = {
                textAlign: "left",
                flexBasis: "auto",
                paddingRight: 26
            },
            _c[theme.mediaQuery(theme.breakpoints.medium)] = {
                flexBasis: "50%",
            },
            _c),
        media: (_d = {
                position: "relative",
                flexBasis: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 40,
                "& > div": {
                    position: "relative",
                    width: "100%",
                    maxWidth: 680,
                    height: "auto",
                    maxHeight: 900,
                    "& img": {
                        width: "auto",
                        maxWidth: "100%",
                        height: "auto",
                        maxHeight: "100%",
                    },
                }
            },
            _d[theme.mediaQuery(theme.breakpoints.medium)] = {
                flexBasis: "50%",
            },
            _d[theme.mediaQuery(theme.breakpoints.medium)] = {
                marginTop: 120,
                "& > div": {
                    maxHeight: "none",
                },
            },
            _d[theme.mediaQuery(theme.breakpoints.large)] = {
                marginTop: 0,
            },
            _d),
        showMobile: (_e = {
                display: "block"
            },
            _e[theme.mediaQuery(theme.breakpoints.medium)] = {
                display: "none",
            },
            _e),
        hideMobile: (_f = {
                display: "none"
            },
            _f[theme.mediaQuery(theme.breakpoints.medium)] = {
                display: "block",
            },
            _f),
    };
});
var Hero = function (_a) {
    var _b;
    var headline = _a.headline, subheadline = _a.subheadline, vendorStyles = _a.vendorStyles, vendorStylesCollection = _a.vendorStylesCollection, graphQLResponse = _a.graphQLResponse;
    var vendor = useGlobalContext().vendor;
    var classes = useStyles({ vendor: vendor, vendorStyles: vendorStyles });
    var hero;
    if (graphQLResponse && vendorStylesCollection) {
        hero = vendorStylesCollection.items.find(function (entry) { return entry.vendor === vendor; });
    }
    else if (vendorStyles) {
        hero = vendorStyles.find(function (entry) { return entry.fields.vendor === vendor; });
    }
    else {
        return null;
    }
    if (!hero) {
        return null;
    }
    // @ts-ignore
    var _c = !graphQLResponse
        ? hero === null || hero === void 0 ? void 0 : hero.fields : hero, lottieAnimation = _c.lottieAnimation, staticImage = _c.staticImage, mobileImage = _c.mobileImage;
    var staticImageUrl = staticImage
        ? !graphQLResponse
            ? staticImage.fields.file.url
            : staticImage.url
        : null;
    var mobileImageUrl = mobileImage
        ? !graphQLResponse
            ? mobileImage.fields.file.url
            : mobileImage.url
        : null;
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.container },
            React.createElement("div", { className: classes.text },
                React.createElement(Typography, { className: classes.headline, variant: "title" }, headline),
                subheadline ? (React.createElement(Typography, { variant: "heading4" }, subheadline)) : null),
            React.createElement("div", { className: classes.media },
                React.createElement("div", null,
                    !lottieAnimation && staticImage && staticImageUrl ? (React.createElement("img", { src: staticImageUrl + "?w=680&h=900", className: classNames((_b = {}, _b[classes.hideMobile] = mobileImage, _b)), alt: "" })) : (React.createElement(Lottie, { options: __assign({ animationData: lottieAnimation }, defaultLottieOptions), height: 400, width: 400 })),
                    !lottieAnimation &&
                        mobileImage &&
                        (mobileImageUrl ? (React.createElement("img", { src: mobileImageUrl + "?w=295&h=295", className: classes.showMobile, alt: "" })) : null))))));
};
Hero.defaultProps = {
    vendorStyles: [],
};
Hero.propTypes = {
    headline: PropTypes.string.isRequired,
    subheadline: PropTypes.string,
    vendorStyles: PropTypes.any,
    graphQLResponse: PropTypes.bool,
};
export default Hero;
